import React from 'react';

import type { FC } from 'react';

export const Mail: FC<React.SVGAttributes<SVGSVGElement>> = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" {...props}>
      <path d="M16.668 3.33398H3.33464C2.41797 3.33398 1.66797 4.08398 1.66797 5.00065V15.0007C1.66797 15.9173 2.41797 16.6673 3.33464 16.6673H16.668C17.5846 16.6673 18.3346 15.9173 18.3346 15.0007V5.00065C18.3346 4.08398 17.5846 3.33398 16.668 3.33398ZM16.3346 6.87565L10.8846 10.284C10.343 10.6257 9.65964 10.6257 9.11797 10.284L3.66797 6.87565C3.45964 6.74232 3.33464 6.51732 3.33464 6.27565C3.33464 5.71732 3.94297 5.38398 4.41797 5.67565L10.0013 9.16732L15.5846 5.67565C16.0596 5.38398 16.668 5.71732 16.668 6.27565C16.668 6.51732 16.543 6.74232 16.3346 6.87565Z" />
    </svg>
  );
};
